import Avatar from './src/components/ui/Avatar.vue';
import Badge from './src/components/ui/Badge.vue';
import Collapse from './src/components/ui/Collapse.vue';
import ColorPicker from './src/components/ui/ColorPicker.vue';
import Datalist from './src/components/ui/Datalist.vue';
import DatePicker from './src/components/ui/DatePicker.vue';
import FileSelector from './src/components/ui/FileSelector.vue';
import Image from './src/components/ui/Image.vue';
import InputAutocomplete from './src/components/ui/InputAutocomplete.vue';
import InputColorPicker from './src/components/ui/InputColorPicker.vue';
import InputDatePicker from './src/components/ui/InputDatePicker.vue';
import InputTags from './src/components/ui/InputTags.vue';
import InputTimePicker from './src/components/ui/InputTimePicker.vue';
import InputUnits from './src/components/ui/InputUnits.vue';
import Lazy from './src/components/ui/Lazy.vue';
import Pagination from './src/components/ui/Pagination.vue';
import Paginator from './src/components/ui/Paginator.vue';
import Popover from './src/components/ui/Popover.vue';
import Popup from './src/components/ui/Popup.vue';
import ResponsiveContainer from './src/components/ui/ResponsiveContainer.vue';
import Select from './src/components/ui/Select.vue';
import TimePicker from './src/components/ui/TimePicker.vue';
import Tooltip from './src/components/ui/Tooltip.vue';
import Grid from './src/components/ui/Grid.vue';
import EditableText from './src/components/ui/EditableText.vue';
import { WysiwygEditor, WysiwygConsts, WysiwygRenderMixins } from './src/components/ui/WysiwygEditor';
// utils stuff
import FormComponent from './src/components/ui/utils/FormComponent';

const Utils = { FormComponent, ...WysiwygRenderMixins };
const Constants = { ...WysiwygConsts };

export {
    Utils,
    Constants,
    Avatar,
    Badge,
    Collapse,
    ColorPicker,
    Datalist,
    DatePicker,
    FileSelector,
    Image,
    InputAutocomplete,
    InputColorPicker,
    InputDatePicker,
    InputTags,
    InputTimePicker,
    InputUnits,
    Lazy,
    Pagination,
    Paginator,
    Popover,
    Popup,
    ResponsiveContainer,
    Select,
    TimePicker,
    Tooltip,
    Grid,
    EditableText,
    WysiwygEditor
};
